export default __webpack_public_path__ + "static/media/home_tree3.84e28020.png";